module.exports = __webpack_public_path__ + "static/media/cross.db78803b.svg";